import api from './api';

const authService = {
  // Check if employee code exists
  checkEmployee: async (empCode) => {
    try {
      const response = await api.post('/api/auth/check-employee', { emp_code: empCode });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to check employee' };
    }
  },

  // Register new user
  register: async (userData) => {
    try {
      const response = await api.post('/api/auth/register', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Registration failed' };
    }
  },

  // Verify email with code
  verifyEmail: async (email, verificationCode) => {
    try {
      const response = await api.post('/api/auth/verify-email', {
        email,
        verification_code: verificationCode,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Verification failed' };
    }
  },

  // Resend verification code
  resendVerification: async (email) => {
    try {
      const response = await api.post('/api/auth/resend-verification', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to resend verification code' };
    }
  },

  // Login
  login: async (email, password, role) => {
    try {
      const response = await api.post('/api/auth/login', { email, password, role });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Login failed' };
    }
  },

  // Forgot password — emails the existing password to a registered email
  forgotPassword: async (email) => {
    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to process request' };
    }
  },

  // Get user profile
  getProfile: async () => {
    try {
      const response = await api.get('/api/auth/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to get profile' };
    }
  },

  // Change password
  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await api.post('/api/auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to change password' };
    }
  },

  // Update profile
  updateProfile: async (fullName) => {
    try {
      const response = await api.put('/api/auth/update-profile', { full_name: fullName });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update profile' };
    }
  },
};

export default authService;
